export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/products`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/products/${ID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/products`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/products/${ID}`;
}

export function ShowVariants(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/products/${ID}/variants`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/products/${ID}`;
}

export function UpdateVariants(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/products/${ID}/variants`;
}

